export interface SubtotalInputs {
  subtotalManual?: number | string | null;
  subtotalPreview?: number | string | null;
  subtotalSnapshot?: number | string | null;
  subtotal?: number | string | null;
}

export function resolveSubtotalFinal(inputs: SubtotalInputs): number {
  const manual = toNumber(inputs.subtotalManual);
  if (manual !== null) {
    return manual;
  }

  const preview = toNumber(inputs.subtotalPreview);
  if (preview !== null) {
    return preview;
  }

  const snapshot = toNumber(inputs.subtotalSnapshot);
  if (snapshot !== null) {
    return snapshot;
  }

  const subtotal = toNumber(inputs.subtotal);
  if (subtotal !== null) {
    return subtotal;
  }

  return 0;
}

export function hasManualSubtotal(value: number | string | null | undefined): boolean {
  const manual = toNumber(value);
  return manual !== null;
}

function toNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
